import React from 'react';
import './UniversityPage.css';

const UniversityPage = () => {
    return (
        <>
            <div className="containerr">

                <header className="header">
                    <h1>University of Messina</h1>
                    <h2>[3016] MEDICINE AND SURGERY | Università degli Studi di Messina</h2>
                </header>

                <section className="overview">
                    <h2>Overview</h2>
                    <p>Founded in 1548, the University of Messina (UniME) is one of Italy’s oldest institutions, known for its strong academic tradition and international collaborations. The university offers various exchange programs, double-degree, and joint-degree opportunities, making it an appealing choice for students worldwide.</p>
                    <p>Messina is located in the eastern part of Sicily, in southern Italy. Although the city itself does not have an airport, it is well-connected through nearby airports in Catania, Palermo, and Reggio Calabria.</p>
                </section>

                <section className="ranking">
                    <h2>International Ranking of UniME</h2>
                    <p>The University of Messina consistently ranks among Italy’s top institutions for medicine and surgery. Its research facilities, faculty expertise, and growing international reputation contribute to its strong global standing.</p>
                    <p>In the newly released QS World University Ranking 2025, the University of Messina (UniME) has improved by over 100 positions, now ranking in the 751-760 bracket globally and 25th in Italy. Among top 500 in the field of Medicine.</p>
                </section>

                <section className="admission">
                    <h2>Admission Requirements</h2>
                    <p>Prospective students must meet the following requirements:</p>
                    <ul>
                        <li>A high school diploma equivalent to the Italian secondary school qualification. Minimum score should be 70%.</li>
                        <li>A valid IMAT score above the cutoff for their category (EU/non-EU).</li>
                        <li>Proof of English proficiency (for non-native speakers).</li>
                        <li>Visa and residence permit for non-EU students.</li>
                    </ul>

                    <section className="ranking">
                        <h3>IMAT Scores in Past Years and Cut-offs</h3>
                        <table>
                            <thead>
                                <tr>
                                    <th>YEAR</th>
                                    <th>Minimum Score (Non-European)</th>
                                    <th>European Scores (First/Last Round)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>2020</td>
                                    <td>28.5</td>
                                    <td>First: 50.4 / Last: 38.9</td>
                                </tr>
                                <tr>
                                    <td>2021</td>
                                    <td>34.6</td>
                                    <td>First: 43.0 / Last: 33.0</td>
                                </tr>
                                <tr>
                                    <td>2022</td>
                                    <td>42.9</td>
                                    <td>First: 42.9 / Last: 33.8</td>
                                </tr>
                                <tr>
                                    <td>2023</td>
                                    <td>36.9</td>
                                    <td>First: 35.2 / Last: 33.0</td>
                                </tr>
                                <tr>
                                    <td>2024</td>
                                    <td>61.4</td>
                                    <td>First: 57.6 / Last: —</td>
                                </tr>
                            </tbody>
                        </table>
                    </section>
                </section>

                <section className="course-structure">
                    <h2>Course Structure and Subjects Taught</h2>
                    <p>The medical degree at UniME spans six years and covers various essential topics. Below are the subjects taught for all 6 years:</p>

                    <h3>Year of study: 1</h3>
                    <ul>
                        <li>BODY ARCHITECTURE (5 CFU - 62.5 hours)</li>
                        <li>FURTHER LEARNING ACTIVITIES (DEBITO O.F.A.) (0 CFU - 0 hours)</li>
                        <li>EARLY CLINICAL CONTACT AND COMMUNICATION SKILLS (1 CFU - 12.5 hours)</li>
                        <li>GENETICS (6 CFU - 75 hours)</li>
                        <li>HISTOLOGY AND EMBRYOLOGY (8 CFU - 100 hours)</li>
                        <li>MEDICAL PHYSICS, STATISTICS AND BIOINFORMATICS (10 CFU - 125 hours)</li>
                        <li>MOLECULAR AND CELLULAR BIOLOGY (9 CFU - 112.5 hours)</li>
                        <li>THE LIVING MATTER (12 CFU - 150 hours)</li>
                    </ul>

                    <h3>Year of study: 2</h3>
                    <ul>
                        <li>EARLY CLINICAL CONTACT AND COMMUNICATION SKILLS (2 CFU - 87.5 hours)</li>
                        <li>HUMAN ANATOMY (8 CFU - 100 hours)</li>
                        <li>MECHANISMS OF DISEASE (12 CFU - 150 hours)</li>
                        <li>MICROBIOLOGY (5 CFU - 62.5 hours)</li>
                        <li>NEUROANATOMY (6 CFU - 75 hours)</li>
                        <li>NEUROPHYSIOLOGY (5 CFU - 62.5 hours)</li>
                        <li>PHYSIOLOGY (7 CFU - 87.5 hours)</li>
                    </ul>

                    <h3>Year of study: 3</h3>
                    <ul>
                        <li>CARDIOVASCULAR AND RESPIRATORY DISEASES (14 CFU - 237.5 hours)</li>
                        <li>CLINICAL LABORATORY MEDICINE (5 CFU - 100 hours)</li>
                        <li>CLINICAL SEMEIOTICS (18 CFU - 325 hours)</li>
                        <li>HEAD AND NECK (11 CFU - 175 hours)</li>
                        <li>INFECTIOUS DISEASES, SKIN AND SEXUALLY TRANSMITTED DISEASES & PLASTIC SURGERY (12 CFU - 187.5 hours)</li>
                    </ul>

                    <h3>Year of study: 4</h3>
                    <ul>
                        <li>ENDOCRINE, METABOLIC AND RHEUMATOLOGICAL DISEASES (11 CFU - 175 hours)</li>
                        <li>GASTROENTEROLOGICAL DISEASES (4 CFU - 62.5 hours)</li>
                        <li>HEMATOLOGY AND ONCOLOGY (11 CFU - 162.5 hours)</li>
                        <li>HYGIENE AND GLOBAL PUBLIC HEALTH (8 CFU - 100 hours)</li>
                        <li>IMAGING AND RADIOTHERAPY (9 CFU - 150 hours)</li>
                        <li>NEPHRO-UROLOGICAL DISEASES (6 CFU - 100 hours)</li>
                        <li>PATHOLOGY (11 CFU - 150 hours)</li>
                    </ul>

                    <h3>Year of study: 5</h3>
                    <ul>
                        <li>LEGAL MEDICINE (5 CFU - 62.5 hours)</li>
                        <li>NEUROSCIENCE (12 CFU - 200 hours)</li>
                        <li>OBSTETRICS AND GYNECOLOGY & FETAL DEVELOPMENT ABNORMALITIES (7 CFU - 112.5 hours)</li>
                        <li>ORTHOPEDICS AND TRAUMATOLOGY & PHYSICAL AND REHABILITATION MEDICINE (5 CFU - 125 hours)</li>
                        <li>PEDIATRIC SCIENCE (11 CFU - 200 hours)</li>
                        <li>PHARMACOLOGY (10 CFU - 125 hours)</li>
                        <li>PSYCHIATRY AND CLINICAL PSYCHOLOGY (7 CFU - 87.5 hours)</li>
                    </ul>

                    <h3>Year of study: 6</h3>
                    <ul>
                        <li>EMERGENCY AND INTENSIVE CARE (10 CFU - 175 hours)</li>
                        <li>GENERAL SURGERY (13 CFU - 212.5 hours)</li>
                        <li>INTERNAL MEDICINE (13 CFU - 225 hours)</li>
                        <li>PRACTICAL-EVALUATION TRAINEESHIP IN THE MEDICAL AREA (5 CFU - 125 hours)</li>
                        <li>PRACTICAL-EVALUATION TRAINEESHIP IN THE SPECIFIC FIELD OF GENERAL MEDICINE (5 CFU - 125 hours)</li>
                        <li>PRACTICAL-EVALUATION TRAINEESHIP IN THE SURGICAL AREA (5 CFU - 125 hours)</li>
                        <li>THESIS (18 CFU - 18 hours)</li>
                        <li>ATTIVITA' DIDATTICHE ELETTIVE (8 CFU)</li>
                    </ul>
                </section>

                <section className="exams">
                    <h2>Exams</h2>
                    <p>In exams, most are oral, and multiple courses are integrated. For example, chemistry and biochemistry are combined into a single course. Although they have different professors, you must pass both subjects to clear the exam. If you fail either one, you will have to retake both.</p>
                    <p>For instance, if you pass biochemistry but fail chemistry, you will need to retake both subjects in the next attempt. Once you pass, you earn the corresponding credits. The minimum passing score is 18 out of 30, while the highest grade is 30 cum laude (30+).</p>
                    <p>In later years, clinical practice is also included. You also have the option to accept or reject your score if you believe you can perform better, in a professional and ethical manner.</p>
                </section>

                <section className="scholarships">
                    <h2>Scholarships and Tuition Fees</h2>
                    <p>At the University of Messina (UniME), the standard tuition fee is €750. However, the actual amount is determined based on the student's ISEE (Equivalent Economic Situation Indicator).</p>
                    <p>Most students are required to pay only €156 at the beginning of the academic year. Out of this, €140 is a regional tax, which is refunded at the end of the year if the student is a scholarship recipient.</p>
                    <p>Scholarships: Managed by ERSU, scholarships are awarded based on academic performance.</p>
                    <a href="https://www.ersumessina.it">https://www.ersumessina.it</a>
                </section>

                <section className="city-info">
                    <h2>Messina as a City</h2>
                    <p>Messina is a vibrant coastal city with a rich history, picturesque landscapes, and a warm Mediterranean climate. Its scenic views, welcoming locals, and affordable living costs make it an attractive destination for students.</p>
                </section>

                <section className="living-expenses">
                    <h2>Living Expenses and International Life in Messina</h2>
                    <ul>
                        <li><strong>Accommodation:</strong> Shared apartments range from €300-500 per month depending on location and amenities.</li>
                        <li><strong>Food and Dining:</strong> Weekly grocery expenses average €30-50 and eating out is affordable.</li>
                        <li><strong>Transportation:</strong> Bus and tram services are available, and students can have a bus pass for 30€ which is valid for 6 months to one year.</li>
                        <li><strong>Social Life:</strong> Messina offers numerous cultural activities, cafes, and seaside relaxation spots. The student community is diverse, providing international students with ample networking opportunities.</li>
                    </ul>
                </section>

                <footer className="footer">
                    <h2>Conclusion</h2>
                    <p>The University of Messina offers an excellent medical program with affordable tuition, strong academic credentials, and a beautiful coastal setting. With structured coursework, rigorous assessments, and ample international exposure, it is an ideal choice for aspiring medical professionals.</p>
                    <p>Whether you are looking for quality education, affordability, or a balanced lifestyle, studying medicine at UniME is a rewarding experience!</p>
                </footer>
            </div>

        </>
    );
};

export default UniversityPage;